import { useAutoNavStack } from "../hooks/useAutoNavStack";
import { PaymentFailedGuard } from "../components/common/PaymentFailedPopup/PaymentFailedGuard";

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  useAutoNavStack();

  return (
    <>
      {children}
      <PaymentFailedGuard />
    </>
  );
};
